/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { NewsRequestUtilService } from '../../utils/news-utils.service';
import { DataApiService } from './data-api-service';
import { map } from 'rxjs/operators';

interface TopNewsResponse {
  stories: Array<{
    main_article: {
      publish_time: string;
      title: string;
      id: string;
      sentiment: string;
      teaser: string;
    };
    story_id: string;
    story_size: number;
    date_from: string;
    date_to: string;
    news_ids: string[];
  }>;
  used_cache: boolean;
  cache_key: string;
}
@Injectable({
  providedIn: 'root',
})
export class TopNewsService {
  constructor(
    private dataApiService: DataApiService,
    private newsRequestUtil: NewsRequestUtilService,
  ) {}

  getTopNews(params: any) {
    const requestBody = this.newsRequestUtil.createTopNewsRequest(
      params.customParams,
      params.body,
    );

    return this.dataApiService
      .post<TopNewsResponse>('stories', requestBody, {}, 'v4')
      .pipe(
        map((responseArg) => {
          const resp = JSON.parse(JSON.stringify(responseArg));
          resp['stories'].forEach((story, indexStory) => {
            if (Object.prototype.hasOwnProperty.call(story, 'main_article')) {
              story['main_article']['events'].forEach((event, indexEvent) => {
                if (event.span && story['main_article'].locations) {
                  if (
                    event.span.end <= story['main_article'].locations.title.end
                  ) {
                    resp['stories'][indexStory]['main_article']['events'][
                      indexEvent
                    ].where = 'title';
                    resp['stories'][indexStory]['main_article']['events'][
                      indexEvent
                    ].span.start -= story['main_article'].locations.title.start;
                    resp['stories'][indexStory]['main_article']['events'][
                      indexEvent
                    ].span.end -= story['main_article'].locations.title.start;
                  } else {
                    resp['stories'][indexStory]['main_article']['events'][
                      indexEvent
                    ].where = 'content';
                    resp['stories'][indexStory]['main_article']['events'][
                      indexEvent
                    ].span.start -=
                      story['main_article'].locations.content.start;
                    resp['stories'][indexStory]['main_article']['events'][
                      indexEvent
                    ].span.end -= story['main_article'].locations.content.start;
                  }
                }
              });
              story['main_article']['matches'].forEach((match, indexMatch) => {
                match['spans'].forEach((span, indexSpan) => {
                  if (span && story['main_article'].locations) {
                    if (span.end <= story['main_article'].locations.title.end) {
                      resp['stories'][indexStory]['main_article']['matches'][
                        indexMatch
                      ]['spans'][indexSpan].location = 'title';
                      resp['stories'][indexStory]['main_article']['matches'][
                        indexMatch
                      ]['spans'][indexSpan].start -=
                        story['main_article'].locations.title.start;
                      resp['stories'][indexStory]['main_article']['matches'][
                        indexMatch
                      ]['spans'][indexSpan].end -=
                        story['main_article'].locations.title.start;
                    } else {
                      resp['stories'][indexStory]['main_article']['matches'][
                        indexMatch
                      ]['spans'][indexSpan].location = 'content';
                      resp['stories'][indexStory]['main_article']['matches'][
                        indexMatch
                      ]['spans'][indexSpan].start -=
                        story['main_article'].locations.content.start;
                      resp['stories'][indexStory]['main_article']['matches'][
                        indexMatch
                      ]['spans'][indexSpan].end -=
                        story['main_article'].locations.content.start;
                    }
                  }
                });
              });
            }
          });
          return resp;
        }),
      );
  }
}
